<!-- Водители -->
<template>
  <li
    v-if="canSeePage('drivers')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Drivers')"
    @mouseup="handleMiddleClick($event, 'Drivers')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Drivers')"
    :class="{ active: activeItem === 'drivers' }"
    :title="collapsed ? 'Водители' : ''"
  >
    <div class="link-icon_box driver-icon">
      <!-- Явный размер сохраняет иконку во flex-контейнере Safari/WebKit. -->
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon driver-svg"
      >
        <rect x="3" y="5" width="20" height="15" rx="2" ry="2" />
        <circle cx="9" cy="11" r="2" />
        <path d="M6 17c0-1.333 1.333-2 3-2s3 0.667 3 2" />
        <line x1="15" y1="10" x2="20" y2="10" />
        <line x1="14" y1="13" x2="20" y2="13" />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Водители</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "DriversItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
